import { render, staticRenderFns } from "./TableBlocked.vue?vue&type=template&id=24ee63c5"
import script from "./TableBlocked.vue?vue&type=script&lang=js"
export * from "./TableBlocked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports